// Cómo se muestra al administrador el estado de la asignación del técnico.
// PENDING pasa a rojo cuando lleva más de 24 h sin que el técnico lo acepte.
export function assignmentView(assignment) {
  if (!assignment || assignment.state === 'DONE') return null
  switch (assignment.state) {
    case 'PENDING': {
      const hours = assignment.pendingHours ?? 0
      const waiting = hours < 1 ? 'hace menos de 1 h' : hours < 48 ? `hace ${hours} h` : `hace ${Math.floor(hours / 24)} días`
      return {
        label: 'Pendiente de aceptar',
        color: hours >= 24 ? '#ef4444' : '#f59e0b',
        icon: 'mdi-clock-outline',
        detail: `Asignado ${waiting}`,
      }
    }
    case 'CONFIRMED':
      return { label: 'Aceptado', color: '#10b981', icon: 'mdi-check-circle-outline', detail: 'El técnico aceptó el ticket' }
    case 'EN_ROUTE':
      return { label: 'En camino', color: '#3b82f6', icon: 'mdi-car-outline', detail: 'El técnico va en camino' }
    case 'ON_SITE':
      return { label: 'En sitio', color: '#8b5cf6', icon: 'mdi-map-marker-check-outline', detail: 'El técnico está en el sitio' }
    default:
      return null
  }
}